<template>
  <div class="bid-box">
      <div style="width:100%;height:100%;position: relative;background: #fff;border-radius: 6px;">
        <div class="box-head">
            <el-page-header @back="goBack" :content="pageTitle"></el-page-header>
        </div>
        <div class="box-btn">
            <el-button :type="curBtn==1?'primary':''" @click="selectStage(1)">前期阶段</el-button>
            <el-button :type="curBtn==2?'primary':''" @click="selectStage(2)">建设验收阶段</el-button>
            <el-button :type="curBtn==3?'primary':''" @click="selectStage(3)">支付阶段</el-button>
            <el-button :type="curBtn==4?'primary':''" @click="selectStage(4)">移交决算阶段</el-button>
            <el-button :type="curBtn==5?'primary':''" @click="selectStage(5)">维保阶段</el-button>
            <!-- <span v-for="(item,index) in btnList" :key="index">
                <el-badge :value="item.val" class="item" v-if="item.val!=0">
                    <el-button :type="curBtn==item.value?'primary':''" @click="selectStage(item.value)">{{item.label}}</el-button>
                </el-badge>
                <el-button v-else :type="curBtn==item.value?'primary':''" @click="selectStage(item.value)">{{item.label}}</el-button>
            </span> -->
        </div>
        <div class="box-main">
            <router-view></router-view>
        </div>
      </div>
  </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
    data(){
        return{
            id:"",
            groupId:'',
            curBtn:0,
            pageTitle:'',//
            btnList:[],
            unitKind:'',
            unitType:'',
        }
    },
    // watch:{
    //     '$store.state.refrshAgree': function(val, old) {
    //         if(val==true){
    //             this.getStageNum()
    //         }
    //         this.$store.commit('setRefrshAgree',false)
    //   }
    // },
    mounted(){
        this.groupId = util.session.get('groupId')
        var params = this.$route.params
        this.id = params.id
        this.getData()
        
    },
    methods:{
        //获取数据
        getData(){
            var that = this
            myHttp.getContractById({
                id:this.id
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.proContract
                    that.pageTitle = data.entProjectName //+' - '+data.name
                    that.unitKind = data.unitKind
                    // that.setStatusFun(data.unitType)
                    var pathName = that.$route.path.split('/')[1]
                    if(pathName=='bidStage1'){
                        that.curBtn = 1
                    }else if(pathName=='buildPhase1'){
                        that.curBtn = 2
                    }else if(pathName=='payPhase1'){
                        that.curBtn = 3
                    }else if(pathName=='transferStage1'){
                        that.curBtn = 4
                    }else if(pathName=='mainStage1'){
                        that.curBtn = 5
                    }
                    if(pathName=='purHead1'){
                        that.curBtn = 1
                        setTimeout(function(){
                            that.$router.push({path:'/bidStage1/'+that.id})
                        },100)
                    }
                }
            })
        },
        //根据合同类型获取按钮
        // setStatusFun(index){
        //     var type = 'collect_type'
        //     var that = this
        //     myHttp.getDictByType({
        //         type:type
        //     }).then(function(resp){
        //         if(resp.data.code=='200'){
        //             var list = resp.data.data.dictList || []
        //             var result = []
        //             for(var i=0;i<list.length;i++){
        //                 if(index!='2'){
        //                     if(i>0){
        //                         result.push(list[i])
        //                     }
        //                 }else{
        //                     result.push(list[i])
        //                 }
        //             }
        //             console.log(result)
        //             that.btnList = result
        //             that.getStageNum()
        //             var pathName = that.$route.path.split('/')[1]
        //             if(pathName=='purHead'){
        //                 that.curBtn = result[0].value
        //                 setTimeout(function(){
        //                     if(index=='2'){
        //                         that.$router.push({path:'/bidStage/'+that.id+'/'+that.curBtn})
        //                     }else{
        //                         that.$router.push({path:'/buildPhase/'+that.id+'/'+that.curBtn})
        //                     }
        //                 },100)
        //             }
        //         }
        //     })
        // },
        //获取每个阶段数量
        // getStageNum(){
        //     var that = this
        //     myHttp.selectVerifyCount({
        //         contractId:this.id,
        //         unitKind:this.unitKind
        //     }).then(function(resp){
        //         if(resp.data.code=='200'){
        //             var data = resp.data.data
        //             var list = that.btnList
        //             that.btnList = []
        //             for(var i=0;i<list.length;i++){
        //                 // if(that.unitKind=='1'){
        //                     if(i==0){
        //                         list[i].val = data.proTender||0
        //                     }else if(i==1){
        //                         list[i].val = data.proBuilding||0
        //                     }else if(i==2){
        //                         list[i].val = data.proPay||0
        //                     }else if(i==3){
        //                         list[i].val = data.proTransitionphase||0
        //                     }else if(i==4){
        //                         list[i].val = data.proMaintent||0
        //                     }
        //                 that.btnList = list
        //             }
        //         }
        //     })
        // },
        //切换阶段
        selectStage(index){
            if(this.curBtn != index){
                this.curBtn = index
                    if(index==1){
                        this.$router.push({path:'/bidStage1/'+this.id})
                    }else if(index==2){
                        this.$router.push({path:'/buildPhase1/'+this.id})
                    }else if(index==3){
                        this.$router.push({path:'/payPhase1/'+this.id})
                    }else if(index==4){
                        this.$router.push({path:'/transferStage1/'+this.id})
                    }else if(index==5){
                        this.$router.push({path:'/mainStage1/'+this.id})
                    }
            }
            
        },
        
        //返回
        goBack(){
            // this.$router.go(-1)
            this.$router.replace({name:'myContract'})
        },
    },
}
</script>

<style scoped>
    .bid-box{
        width: 100%;
        height: 100%;
        position: relative;
        padding: 1vh;
    }
    .box-head{
        width: 100%;
        height: 6vh;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;
        justify-content: flex-start;
        justify-items:flex-start;
        border-bottom: 1px solid #ddd;
        padding: 1vh 1vw;
    }
    .box-btn{
        width: 100%;
        height: 7vh;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        align-content: center;
        align-items: center;
        border-bottom: 10px solid #ecf0f5;
    }
    .box-main{
        width: 100%;
        height: calc( 100% - 13vh );
        position: relative;
        overflow: auto;
        padding: 1vh;
    }
</style>

<style>

</style>